import { SEC_AUTH_M_TK } from 'constants/AuthConstant';
import {
  getTenantIdFromToken,
  getUserIdFromTokenNum,
  getUserEmailFromToken,
} from 'utils/jwtUtils';

const PLAYGROUND_HISTORY_PREFIX = 'chatHistory_';

const sanitizeKeyPart = (value) => String(value || '').replace(/[^a-zA-Z0-9._-]/g, '_');

/**
 * Stable per-account scope so Playground history is not shared across users on the same browser.
 */
export const getPlaygroundUserScope = () => {
  const token =
    localStorage.getItem(SEC_AUTH_M_TK) || localStorage.getItem('sec_auth_m_tk');

  const tenantId = getTenantIdFromToken(token);
  if (tenantId != null && tenantId !== '') {
    return `t_${sanitizeKeyPart(tenantId)}`;
  }

  const userId = getUserIdFromTokenNum(token);
  if (userId != null) {
    return `u_${sanitizeKeyPart(userId)}`;
  }

  const email = getUserEmailFromToken(token) || localStorage.getItem('_un');
  if (email) {
    return `e_${sanitizeKeyPart(email)}`;
  }

  return 'anonymous';
};

export const getPlaygroundHistoryKey = (contextId) => {
  if (!contextId) return null;
  return `${PLAYGROUND_HISTORY_PREFIX}${getPlaygroundUserScope()}_${sanitizeKeyPart(contextId)}`;
};

const SCOPED_PLAYGROUND_KEY = /^chatHistory_(t|u|e)_/;

/**
 * Removes old Playground keys (chatHistory_<kb> only) that were not scoped per account.
 */
export const clearLegacyUnscopedPlaygroundHistory = () => {
  const keys = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith(PLAYGROUND_HISTORY_PREFIX) && !SCOPED_PLAYGROUND_KEY.test(key)) {
      keys.push(key);
    }
  }
  keys.forEach((key) => localStorage.removeItem(key));
};

/**
 * Removes Playground chat history from localStorage (scoped + legacy unscoped keys).
 */
export const clearAllPlaygroundChatHistory = () => {
  const keys = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith(PLAYGROUND_HISTORY_PREFIX)) {
      keys.push(key);
    }
  }
  keys.forEach((key) => localStorage.removeItem(key));
};
